/**
 * Combines multiple refs into a single ref callback. Meant to be used with React Hook Form's controller
 * while still allowing external refs to be passed down to the underlying component
 * @param refs - An array of refs to combine (can be function refs or object refs)
 * @returns A single ref callback that assigns the element to all provided refs
 */
export const combineRefs = <T extends HTMLElement>(
  ...refs: Array<React.ForwardedRef<T> | undefined>
): React.RefCallback<T> => {
  return (element) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(element);
      } else if (ref) {
        ref.current = element;
      }
    });
  };
};
